import React from 'react';
import { ZdsButton } from '@zig-design-system/ui-components-react';
import Translation from '../../../../Shared/components/Translation';
const BackButton = () => {
    const goBackToOverview = () => {
        if (document.referrer.indexOf(window.location.host) !== -1 && history.length > 1) {
            window.history.back();
        }
        else {
            window.location.href = getOverviewUrl();
        }
    };
    const getOverviewUrl = () => {
        let url = '#/';
        const query = window.location.hash.split('?')[1];
        if (query) {
            url = url + '?' + query;
        }
        return url;
    };
    return (React.createElement(ZdsButton, { onZdsClick: goBackToOverview },
        React.createElement(Translation, { item: "tx_zigrealestate.details.list_link" })));
};
export default BackButton;
